import { PlanSelectionLayout } from '../../../models/layout'
import { Product } from '../../../models/product'
import { RadioButtons } from '../radio-buttons'
import { TileButtons } from '../tile-buttons'

export const templateFactory = (template: string, product: Product): PlanSelectionLayout => {
  switch (template) {
    case 'tiles':
      return new TileButtons()
    case 'radio':
    default:
      return new RadioButtons()
  }
}
